import React from "react";
import { Tooltip, Button, message } from "antd";
import { PhoneOutlined } from "@ant-design/icons";
import "./callingButton.css";

const CallingButton = () => {
  const handleCallingButton = (e) => {
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (!isMobile) {
      e.preventDefault();
      message.warning("Calling is only supported on mobile devices.");
    }
  };

  return (
    <div className="floating-calling-container">
      <Tooltip title="Call us" placement="left">
        <a href="tel:+045771575" onClick={handleCallingButton}>
          <Button
            type="primary"
            shape="circle"
            icon={<PhoneOutlined />}
            size="large"
            style={{
              backgroundColor: "#2196F3",
              borderColor: "#2196F3",
              fontSize: "30px",
              width: "60px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </a>
      </Tooltip>
    </div>
  );
};

export default CallingButton;